import { createAdvancedFilters } from '@common/Util';
import { getService } from '@services/axiosUtil.js';
import * as serviceConstants from '@services/Constants';

export const createAttachmentService = async (guid, advancedFilters) => {
  return getService(
    `${serviceConstants.MEA_SERVER_CONFIGURATION.resource.customerEventsAttachments.replace(':eventId', guid)}` +
      (advancedFilters ? `?${createAdvancedFilters(advancedFilters)}` : ''),
    null,
    true,
    false
  );
};
